import ReactDOM from "react-dom/client";
import html2canvas from 'html2canvas';

import React, { useEffect, useState } from "react";
import app from "../components/app" 
import {cssFiles, jsFiles, svgIcon} from "../components/utility"
import {UndoRedo} from "../components/app" 
import {DisplayForms, AppBlocks, ViewPort, AppLink as Link, linkPopup, AiModal, DeleteModal} from "../components/helpers" 
import Widget from "../preview"  

const updateLogoDB = async function(logo) {
    let response = null;
    if(localStorage.getItem("aiPageId")) {
        if(localStorage.getItem("aiPageId").indexOf('header_') !== -1){
            response = await app.fetchPost({ method:"getFooter", appId:localStorage.getItem("aiAppId"), userId:"123456" });
            console.log("getFooter", response);
            response = JSON.parse(response.footerData);
            response.elements.logo.properties.src = logo;
            await app.fetchPost({method:"saveFooter",appId:localStorage.getItem("aiAppId"),userId:"123456",footerJson:JSON.stringify(response)});
        }
        if(localStorage.getItem("aiPageId").indexOf('footer_') !== -1){
            response = await app.fetchPost({ method:"getHeader", appId:localStorage.getItem("aiAppId"), userId:"123456" });
            console.log("getHeader", response);
            response = JSON.parse(response.headerData);
            response.elements.logo.properties.src = logo;
            await app.fetchPost({method:"saveHeader",appId:localStorage.getItem("aiAppId"),userId:"123456",headerJson:JSON.stringify(response)});
        } 
    }
    return response;
}
const openPopup = function(callback){
    const div = document.createElement("div");
    div.setAttribute("class", "root-popup");
    document.body.appendChild(div);
    const root = ReactDOM.createRoot(div);
    root.render(<AppBlocks callback={callback} />, div);
}

const addFocus = function(ele, clickElement, mode){
    if(mode) {
        ele.setAttribute("contenteditable", true);
        ele.addEventListener("paste", app.htmlPaste);
        ele.addEventListener("blur", clickElement);
        ele.addEventListener("input", window.isCommand);
        ele.addEventListener("keydown", function(event){
            if(event.currentTarget.classList.contains("button")) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                }
            }
           
        });
    }
    else {
        ele.removeAttribute("contenteditable");
        ele.removeEventListener("paste", app.htmlPaste);
        ele.removeEventListener("blur", clickElement);
        ele.removeEventListener("input", window.isCommand);
        ele.removeEventListener("keydown", function(event){
            if(event.currentTarget.classList.contains("button")) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                }
            }
        });
    }
}
const PreviewIframe = function() {
    let iframeStyle = {}
    if(!app.getDevice()) {
        iframeStyle = {
            maxWidth:"400px",
            margin:"0px auto",
            display:"block"
        }
    }
    let previewHost = 'https://preview.mediadirhub.com';
    if(window.location.host.indexOf("pbodev.info") !== -1) {
        previewHost = "https://ai-builder-preview.pages.dev";
    }
    return <div className="w-100 h-100 p-0 position-absolute start-0 top-0" style={{zIndex:"1000", background:"#fff"}}>
        <iframe id="previewIframe" className="w-100 h-100" style={iframeStyle} src={`${previewHost}/${app.getDevice()?"desktop":"mobile"}-preview/${localStorage.getItem("aiAppId")}/${localStorage.getItem("aiPageId")}?lang=${app.appLang()}`} />
    </div>
}



const ActionBlock = function({langSettings, actionClick, index, widgetType}) {
    let fetchCode = <a className="iconz-download tool-tip" onClick={actionClick} data-index={index}>
        <span className="tooltip-text">FETCH</span>
    </a>
     let copyCode = <a className="icon-code tool-tip" onClick={actionClick} data-index={index}>
     <span className="tooltip-text">JSON</span>
    </a>
    if(window.location.href.indexOf("/blocks/") === -1) {
        fetchCode = "";
        copyCode = "";
    }

    let copyItem = <a className="copyItem tool-tip ms-0" onClick={actionClick} data-index={index}>
        {svgIcon.copy}
        <span className="tooltip-text">{langSettings.copy}</span>
    </a>

    let deleteItem = <a className="deleteItem tool-tip w-100 mb-0  ms-0" data-index={index} onClick={actionClick}>
        {svgIcon.delete}
        <span>{langSettings.remove}</span>
        <span className="tooltip-text">{langSettings.remove}</span>
    </a>

    let groupItem = <div className="d-flex justify-content-between  w-100">
        <a className="moveUp tool-tip  ms-0" onClick={actionClick} data-index={index}>
            {svgIcon.up}
            <span className="tooltip-text">{langSettings.up}</span>
        </a>
        <a className="moveDown tool-tip ms-0" onClick={actionClick} data-index={index}>
            {svgIcon.down}
            <span className="tooltip-text">{langSettings.down}</span>
        </a> 

        {copyItem}
    </div> 

    if(widgetType === "webAppConverter" || widgetType === "webAppConverterTwo"){
        copyItem = <a className="copyItem tool-tip ms-0 webAppConverter" data-index={index}>
            {svgIcon.copy}
            <span className="tooltip-text">{langSettings.copy}</span>
        </a>
    }

    

    if(widgetType === "webAppConverter" || widgetType === "webAppConverterTwo"){
        deleteItem = <a className="deleteItem tool-tip w-100 mb-0  ms-0" data-index={index}>
            {svgIcon.delete}
            <span>{langSettings.remove}</span>
            <span className="tooltip-text">{langSettings.remove}</span>
        </a>
    }

    let elSpace = ""
    if(widgetType === "headerAi" || widgetType === "footerAi"){
        groupItem = "";
        deleteItem = ""
        elSpace = "mb-0"
    }

    return <div className="actions action-block">
      {fetchCode}
      {copyCode}
    
      <a className={`editItem tool-tip w-100 me-0 ms-0 ${elSpace}`} onClick={actionClick} data-index={index}>
        {svgIcon.edit}
        <span className="d-md-block d-none">{langSettings.editSection}</span>
        <span className="d-md-none">{langSettings.edit}</span>
        <span className="tooltip-text">{langSettings.edit}</span>
      </a>
      {groupItem}
      {deleteItem}

    </div>
}



const setOffset = function(obj) { 
    // console.log("obj", obj.getAttribute("data-key"))
    window.aiElementInfo = {
        index:obj.getAttribute("data-index"),
        grid:obj.getAttribute("data-grid"),
        id:obj.getAttribute("id"),
        gridId:obj.getAttribute("data-id"),
        dataKey:obj.getAttribute("data-key"),
        text:obj.innerHTML,
    }
 

    // console.log("aaaa", obj.getBoundingClientRect().top, app.getWin().scrollY, obj.offsetHeight)
    
    if(obj.getBoundingClientRect().top < 45){
        let el_height = obj.offsetHeight;
        // console.log("el_height", el_height, obj.getBoundingClientRect().top)
        document.querySelector(".main-editor").style.top =  (el_height + 15) + "px";
        if ( app.isMobile() === "is-mobile" ) { 
            document.querySelector(".main-editor").style.left =  (obj.getBoundingClientRect().left + 3) + "px";
        }else{ 
            document.querySelector(".main-editor").style.left =  (obj.getBoundingClientRect().left -3) + "px"; 
        } 
        document.querySelector(".main-editor").style.display = "flex";
        document.querySelector(".main-editor").setAttribute("data-view", obj.getAttribute("data-id"))
    }
    else{
        document.querySelector(".main-editor").style.top =  (app.getWin().scrollY + obj.getBoundingClientRect().top - 48) + "px";
        if ( app.isMobile() === "is-mobile" ) { 
            document.querySelector(".main-editor").style.left =  (obj.getBoundingClientRect().left + 3) + "px";
        }else{ 
            document.querySelector(".main-editor").style.left =  (obj.getBoundingClientRect().left -3) + "px"; 
        } 
        
        document.querySelector(".main-editor").style.display = "flex"; 
        document.querySelector(".main-editor").setAttribute("data-view", obj.getAttribute("data-id")) 
    } 
    // console.log("window.aiElementInfo", obj.getAttribute("data-index"))  
    
}  
  

const updatePosition = function(ele, top, left) { 
    if(top) { 
      localStorage.setItem("oldSelect", JSON.stringify({
        top,
        left
      }))
      ele.style.top = top + "px";
      ele.style.left = left + "px";
    }
    else {
      const temp = JSON.parse(localStorage.getItem("oldSelect"));
      ele.style.top = temp.top + "px";
      ele.style.left = temp.left + "px";
    }
  }
  
  function dragEle() {
    var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    const elmnt = document.querySelector(".box-pop-wrapper");
    elmnt.querySelector(".drag-pointer").onmousedown = dragMouseDown;
  
    function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      if(app.getDom().querySelector(".all-widgets")) {
        app.getDom().querySelector(".all-widgets").classList.add("editor-dragging");
      }
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }
  
    function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      let top = (elmnt.offsetTop - pos2);
      let left = (elmnt.offsetLeft - pos1);
      localStorage.setItem("oldSelect", JSON.stringify({
        top,
        left
      }));
      
      elmnt.style.top = top + "px";
      elmnt.style.left = left + "px";
      elmnt.style.position = "absolute";
    }
  
    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      if(app.getDom().querySelector(".all-widgets")) {
        app.getDom().querySelector(".all-widgets").classList.remove("editor-dragging");
      }
      document.onmouseup = null;
      document.onmousemove = null;
    }
  }

  
  

let oldSelect  = null;

function getOffset(el, mode) {
  if(mode) {
    if(!el.classList.contains("block")) {
      if(oldSelect === el) {
        //return null;
      }
    }
  }
  
  const rect = el.getBoundingClientRect();
  oldSelect = el;
  const data = {
    left: rect.left + app.getWin().scrollX,
    top: rect.top + app.getWin().scrollY,
    x: document.body.clientHeight + app.getWin().scrollX,
    y: document.body.clientHeight + app.getWin().scrollY,
  }
  return data;
} 

const newBackPage = function() {

}
const savePreview = function() {

}

 

const selectEle  = function(onlyParent) {
   
    const selectedEl = app.getDom().querySelector(".selected");
    const formEle = document.querySelector(".box-pop-wrapper");
    // console.log("formEle", formEle)
    // formEle.querySelector(".nav-link").click();
    // formEle.querySelector(".close-popup").addEventListener("click", function() {
    //     //When i click on edit section on right sticky pan 
    //     document.querySelector("body").classList.remove("rootEdit");
    // })


    // const selectedEl = app.getDom().querySelector(".selected");
    
    const position = getOffset(selectedEl, true); 
    const marginTop = 68;
    let top = 0;
    let left = 0;

    const aiEditor = document.querySelector("#ai-editor")
    
    if ((position.left + selectedEl.clientWidth + 360) > aiEditor.clientWidth) {
        left = (aiEditor.clientWidth - 380);
    }
    else {
        left = (selectedEl.clientWidth + position.left + 10);
    }
    if ((position.top + 360) > position.y) {
        top = (position.y - 380 - marginTop);
    }
    else {
        top = (position.top - marginTop);
    }
   // updatePosition(formEle, top, left);
    if(formEle) { 
        formEle.querySelector(".nav-link").click();
        formEle.classList.add("sticky-on-child");
        document.querySelector("body").classList.add("sticky-mode");
         if(onlyParent) {
            formEle.classList.remove("sticky-on-child");
            formEle.classList.add("sticky-on"); 
        } 
        formEle.querySelector(".close-popup").addEventListener("click", function() { 
               //When i click on edit section on right sticky pan 
            document.querySelector("body").classList.remove("rootEdit");
        }) 
    }
    dragEle();
}

let dragItem = null;
const moveItem = function(items,from, to) {
    items.splice(to, 0, items.splice(from, 1)[0]);
    return items;
};

export default class App extends React.Component {

    constructor(props) {
        super(props);
        this.touchStartY = 0;
        this.touchEndY = 0;
        this.state = {
            data:null,
            edit:{
                index:null,
                grid:null,
                id:null
            },
            langSettings:app.getConfig().languageSettings,
            expand:false
        }
        this.updateData = this.updateData.bind(this);
        this.clickElement = this.clickElement.bind(this);
        this.actionClick = this.actionClick.bind(this);
        this.loadIframe = this.loadIframe.bind(this);
        this.renderPage = this.renderPage.bind(this);
        this.unselect = this.unselect.bind(this);
        this.updateText = this.updateText.bind(this);
        this.bindHTML = this.bindHTML.bind(this);
        this.newPublishPage = this.newPublishPage.bind(this);
        this.editorLink = this.editorLink.bind(this);
        this.editorLink2 = this.editorLink2.bind(this);
        this.textUpdate = this.textUpdate.bind(this);
        this.saveAiPage = this.saveAiPage.bind(this);
        this.headerCallback = this.headerCallback.bind(this);
        this.undoRedo = this.undoRedo.bind(this);
        this.renderData = this.renderData.bind(this);
        this.aiPopup = this.aiPopup.bind(this);
        this.makeSelect = this.makeSelect.bind(this);
        this.setExpand = this.setExpand.bind(this);
        this.autoSave = this.autoSave.bind(this);
        this.logoUpdate = this.logoUpdate.bind(this);
    }
    componentWillMount() {
        app.fetchBuilder({
            project:"files",
            domain:"karmtrust.org",
            method:"getImages"
        }).then(function(response){
            if(response.success) {
                localStorage.setItem("allImages", JSON.stringify(response.data));
            }
        });
    }
    undoRedo(response, type) {
        const self = this;
        if(type === "undo") {
            app.saveRedo(self.state.data);
        }
        if(type === "redo") {
            app.saveUndo(self.state.data);
        }
        self.setState({
            data:response
        }, function(){
            self.renderPage(response);
        });
    }
    headerCallback(text) {
        const self = this;
        if(text === "mobile") {
            if(document.querySelector(".wb-header .view-ui .h-mobile")) {
                document.querySelector(".wb-header .view-ui .h-mobile").click();
            }
            if(document.querySelectorAll(".device-view-switch a")) {
                document.querySelectorAll(".device-view-switch a").forEach(function(v){
                    v.classList.remove("active")
                })
                document.querySelectorAll(".device-view-switch a")[0].classList.add("active");
            }
            window.setPreviewDevice("mobile");
        }
        if(text === "desktop") {
            if(document.querySelector(".wb-header .view-ui .h-desktop")) {
                document.querySelector(".wb-header .view-ui .h-desktop").click();
            }
            if(document.querySelectorAll(".device-view-switch a")) {
                document.querySelectorAll(".device-view-switch a").forEach(function(v){
                    v.classList.remove("active")
                });
                if(document.querySelectorAll(".device-view-switch a")[1]) {
                    document.querySelectorAll(".device-view-switch a")[1].classList.add("active");
                }
            }
            window.setPreviewDevice("desktop")
        }
        if(text === "undo") {
            document.querySelector(".undo-redo-container .undo").click();
            console.log(text);
        }
        if(text === "redo") {
            document.querySelector(".undo-redo-container .redo").click();
            console.log(text);
        }
        if(text === "expand") {
            
            if(document.querySelector("body").classList.contains("expand-view")) {
                document.querySelector("body").classList.remove("expand-view");
                self.setExpand(false);
            }
            else {
                document.querySelector("body").classList.add("expand-view");
                self.setExpand(true);
            }
        }
        
    }
    setExpand(expand) {
        const self = this;
        self.setState({
            expand
        })
    }
      
      
    updateText(e){
       this.textUpdate();
    };
    selectBlock(index, id, grid, gridId) {
       // app.getDom().querySelectorAll(".block")[index];
    }
    textUpdate(mode) {
        const self = this;
        if(app.getDom().querySelector(".block .selected")) {
            const ele = app.getDom().querySelector(".block .selected");
            if(ele.classList.contains("text") || ele.classList.contains("textHtml") || ele.classList.contains("button")) {
                
                const id = ele.getAttribute("id");
                const index = ele.getAttribute("data-index");
                const grid = ele.getAttribute("data-grid");
                const gridId = ele.getAttribute("data-id");
                const nextData = JSON.parse(JSON.stringify(self.state.data.dynamicAIData));
                
                let removeBrHTML =  ele.innerHTML;
                if(ele.classList.contains("button")) {
                    removeBrHTML =  ele.innerHTML.replace(/<br\s*\/?>\s*$/, "");
                }
                if(grid) {
                    nextData[index].elements[gridId].items[grid][id]["text"] = removeBrHTML;
                }
                else {
                    nextData[index].elements[id]["text"] = removeBrHTML;
                }
                
                console.log(mode);
                self.updateData(nextData, mode);
            }
        }
    }

    makeSelect() {
        // console.log("bbbbb")
        const self = this; 
        
        const ele = app.getDom().querySelector(".selected");
        if(ele.classList.contains("active")) {
            return false;
        }
        // console.log("cccc")
        //current edit to do not remove bottom right Sheet
        app.getDom().querySelectorAll(".active").forEach(function(v){
            v.classList.remove("active"); 
        });
        ele.classList.add("active"); 

        //current edit to remove parent border
        app.getDom().querySelectorAll(".block").forEach(function(v){
            if(v.getAttribute('data-index') == ele.getAttribute("data-index")){
                v.classList.add("activeHover"); 
            }
        });

        //current edit to remove parent border
        app.getDom().querySelectorAll(".elements-grid").forEach(function(v){
            if(v.getAttribute('data-index') == ele.getAttribute("data-index")){
                v.classList.add("activeHover"); 
            }
        });

        if(!document.querySelector("body").classList.contains("collapse-sidebar") && app.isMobile() !== "is-mobile"){
            document.querySelector("body").classList.add("collapse-sidebar");
        }
        
        //When i click on Any element section I added bottomSheet class to hide right sticky pan
        if(document.querySelector("body").classList.contains("bottomSheet")){
            document.querySelector("body").classList.remove("bottomSheet");
        } 

        if ( app.isMobile() === "is-mobile" ) { 
            //bottom right Sheet on Mobile
            document.body.classList.add("isBottomView");  
        }
        app.getDom().querySelectorAll("[contenteditable]").forEach(function(v){
           addFocus(v, self.clickElement);
        })

        const id = ele.getAttribute("id");
        const index = ele.getAttribute("data-index");
        const grid = ele.getAttribute("data-grid");
        const gridId = ele.getAttribute("data-id");  
        self.setState({
            edit:{
                id,
                grid,
                gridId,
                index 
            }
        }, function(){  
            //hide current edit button
            document.querySelector(".main-editor").style.display = "none";
            if(ele.classList.contains("text") || ele.classList.contains("textHtml") || ele.classList.contains("button")) { 
                if ( app.isMobile() !== "is-mobile" ) { 
                    ele.setAttribute("contenteditable", true);
                } 
                ele.focus();
                //window.isCommand(); 
            }   
            selectEle();
        }) 
    }

    
    clickElement(e) {
        const self = this;
        const ele = e.currentTarget;
        const {edit} = self.state;

        const id = ele.getAttribute("id");
        const index = ele.getAttribute("data-index");
        const grid = ele.getAttribute("data-grid");
        const gridId = ele.getAttribute("data-id"); 
        
        const t = e.type;
        if(t === "focus") { 
            window.tempHTML = ele.innerHTML;
            addFocus(ele, self.clickElement, true); 
        }
        if(t === "blur") {
            console.log("blur")
            if(ele.classList.contains("text") || ele.classList.contains("textHtml") || ele.classList.contains("button")) {
                let data = [];
                //console.log(self.state.data);
                if(self.state.data) {
                    console.log("blur yes");
                    data = JSON.parse(JSON.stringify(self.state.data.dynamicAIData));
                }
                else {
                    console.log("blur no");
                    data = JSON.parse(localStorage.getItem("aiPageData")).dynamicAIData;
                }
               
                if(window.tempHTML !== ele.innerHTML) {
                    let removeBrHTML =  ele.innerHTML;
                    if(ele.classList.contains("button")) {
                        removeBrHTML =  ele.innerHTML.replace(/<br\s*\/?>\s*$/, "");
                    }
                    if(grid) {
                        data[index].elements[gridId].items[grid][id]["text"] = removeBrHTML;
                    }
                    else {
                        data[index].elements[id]["text"] = removeBrHTML;
                    }
                    self.updateData(data);
                }
            }
        }
        
        if(t === "click") { 
            if(ele.classList.contains("active")){
                if(ele.classList.contains("text") || ele.classList.contains("textHtml") || ele.classList.contains("button")) { 
                    window.isCommand(e);
                }
                return false
            }
           //When i click on Any element section I added bottomSheet class to hide right sticky pan
            document.querySelector("body").classList.add("bottomSheet");

            if(document.querySelector("body").classList.contains("bottomSheet")){
                this.setState({
                    edit:{
                        index:null,
                        grid:null,
                        id:null 
                    }
                })
            }
            //When i click on edit section on right sticky pan
            document.querySelector("body").classList.add("rootEdit");

            //current edit to selected class
            app.getDom().querySelectorAll(".selected").forEach(function(v){
                v.classList.remove("selected");
                //v.removeAttribute("contenteditable");
            }); 
            ele.classList.add("selected"); 

            
            //current edit to remove parent border
            app.getDom().querySelectorAll(".activeHover").forEach(function(v){
                v.classList.remove("activeHover"); 
            })
           
            if(!ele.classList.contains("image") || !ele.classList.contains("socialLinks") || !ele.classList.contains("button") || !ele.classList.contains("icon") || !ele.classList.contains("hours") || !ele.classList.contains("contactLinks") || !ele.classList.contains("hideAi") || !ele.classList.contains("mobileHeader") || !ele.classList.contains("logo") || !ele.classList.contains("headerIcons") || !ele.classList.contains("navigation") || !ele.classList.contains("footerNavigation") || !ele.classList.contains("advanceSocialLinks") || !ele.classList.contains("video") || !ele.classList.contains("copyRight") || !ele.classList.contains("headerText")) { 
                setOffset(ele);
            } else{
                //hide current edit button
                document.querySelector(".main-editor").style.display = "none";
            }
            
            if(ele.classList.contains("image") || ele.classList.contains("socialLinks") || ele.classList.contains("button") || ele.classList.contains("icon") || ele.classList.contains("hours") || ele.classList.contains("contactLinks") || ele.classList.contains("hideAi")  || ele.classList.contains("mobileHeader") || ele.classList.contains("logo") || ele.classList.contains("headerIcons") || ele.classList.contains("navigation") || ele.classList.contains("footerNavigation") || ele.classList.contains("advanceSocialLinks") || ele.classList.contains("video") || ele.classList.contains("copyRight") || ele.classList.contains("headerText")){
                this.makeSelect() 
            }

            if(ele.classList.contains("active")){
                // console.log("aaa")
                this.makeSelect() 
            }else{
                app.getDom().querySelectorAll(".active").forEach(function(v){
                    v.classList.remove("active"); 
                    //v.removeAttribute("contenteditable");
                }); 
                app.getDom().querySelectorAll("[contenteditable]").forEach(function(v){
                    addFocus(v);
                })
            } 

            //bottom right Sheet on Mobile
            if(document.body.classList.contains("isBottomView")){
                document.body.classList.remove("isBottomView");
            }
            if(document.body.classList.contains("isRoot")){
                document.body.classList.remove("isRoot");
                app.getDom().body.classList.remove("isRoot");
            }
             
        }
        if(t === "dblclick") { 
            this.makeSelect()
        } 
        if(t === "mouseover") {  
            if(ele.classList.contains("block")) { 
                document.querySelectorAll(".app-overlay .block-view").forEach(function(v){
                    v.classList.remove("hover");
                    if(v.classList.contains("hoverMobile")){
                        v.classList.remove("hoverMobile");
                    }
                    
                })
                if(document.querySelector(`.app-overlay .block-view[data-index="${ele.getAttribute("data-index")}"]`)){
                    document.querySelector(`.app-overlay .block-view[data-index="${ele.getAttribute("data-index")}"]`).classList.add("hover")
                }
                
            }
            else {
                //remove all hover
                app.getDom().querySelectorAll(".hover").forEach(function(v){
                    v.classList.remove("hover");
                });
                ele.classList.add("hover"); 
            }
        } 
    }
    actionClick(e) {
        const self = this;
        const {data} = self.state;
        const ele = e.currentTarget;

        const id = ele.getAttribute("id");
        const index = ele.getAttribute("data-index");
        const grid = ele.getAttribute("data-grid");
        const gridId = ele.getAttribute("data-id"); 

        const t = e.type; 
        if(t === "dragstart") {
            app.getDom().querySelector(`.block[data-index="${index}"]`).classList.add("item-dragging");
            dragItem = {
                index, grid, gridId
            } 
        }
        if(t === "dragend") {
            app.getDom().querySelector(`.block[data-index="${index}"]`).classList.remove("item-dragging");
            //console.log("dragend");
        }
        if(t === "drop") {
            //onsole.log("drop");
            data.dynamicAIData[index].elements[gridId].items = moveItem(data.dynamicAIData[index].elements[gridId].items, dragItem.grid, grid);
            self.renderData(data);
        }
        if(t === "dragover") {
            ele.classList.add("dragging-over");
            e.preventDefault();
        }
        if(t === "dragleave") {
            ele.classList.remove("dragging-over")
        }
        if(t === "click") {
            // console.log("ele", ele)
            if(ele.classList.contains("add-section")) {
                if(data.dynamicAIData.length === 0) {
                    openPopup(function(item){
                        data.dynamicAIData.push(JSON.parse(item));
                        self.renderData(data);
                    });
                }
                else {
                    openPopup(function(item){
                        const newData = JSON.parse(item);
                        newData["viewId"] = "aus_" + Date.now();
                        if(ele.classList.contains("top")) {
                            data.dynamicAIData.splice(parseInt(index), 0, newData);
                            self.renderData(data, function(){
                                // console.log("renderData", index);
                                self.moveWidget(index, "addUp") 
                            }); 
                        }
                        else {
                            data.dynamicAIData.splice(parseInt(index)+1, 0, newData);
                            self.renderData(data, function(){
                                // console.log("renderData", index);
                                self.moveWidget(index, "addDown") 
                            });
                        }
                        // self.renderData(data);
                        
                    });
                }
                // if(index == 0) {
                //     data.dynamicAIData.push()
                // }
                
            }
            if(ele.classList.contains("add-first-section")) {
                openPopup(function(item){
                    const firstJson = [data.dynamicAIData[0], JSON.parse(item), data.dynamicAIData[1]];
                    data.dynamicAIData = firstJson.filter(function(v){
                        if(v) {
                            return true;
                        }
                        return false;
                    });
                    self.renderData(data);
                });
            }

            if(ele.classList.contains("iconz-download")) {
                app.getMaster(data.dynamicAIData[index].widgetType, function(response){
                    if(response) {
                        data.dynamicAIData[index].elements = JSON.parse(response.data).elements;
                        data.dynamicAIData[index].properties = JSON.parse(response.data).properties;
                        if(data.dynamicAIData[index].lang){
                            data.dynamicAIData[index].lang = JSON.parse(response.data).lang;
                        } 
                        self.renderData(data);
                    }
                })
                //console.log(data.dynamicAIData[index]);
                //id
            }
            if(ele.classList.contains("icon-code")) {
                const jsonString = JSON.stringify(data.dynamicAIData[index], null, 2); // Pretty-print with 2 spaces
                navigator.clipboard.writeText(jsonString)
                .then(() => {
                    alert('JSON copied to clipboard!');
                })
                .catch(err => {
                    alert('Failed to copy JSON: ' + err);
                    console.error(err);
                });
            }
            if(ele.classList.contains("editItem")) { 
                self.setState({
                    edit:{
                        index,
                        id,
                        gridId,
                        grid 
                    }
                }, function(){
                     
                    //When i click on edit section on right sticky pan
                    document.querySelector("body").classList.add("rootEdit");
                   
                   
                    

                    //When i click on Any element section I added bottomSheet class to hide right sticky pan
                    if(document.querySelector("body").classList.contains("bottomSheet")){
                        document.querySelector("body").classList.remove("bottomSheet");
                    }
                    
                    //current edit to selected class
                    app.getDom().querySelectorAll(".selected").forEach(function(v){
                        v.classList.remove("selected");
                    });

                    //remove all hover
                    app.getDom().querySelectorAll(".hover").forEach(function(v){
                        v.classList.remove("hover"); 
                    });

                    //hide current edit button
                    document.querySelector(".main-editor").style.display = "none";
                    // app.getDom().querySelectorAll("[contenteditable]").forEach(function(v){
                    //     v.removeAttribute("contenteditable");
                    // }) 
                    if(grid) {
                        app.getDom().querySelectorAll(".block")[index].querySelectorAll(".elements-grid")[grid].classList.add("selected");
                        selectEle();
                    }
                    else {
                        app.getDom().querySelectorAll(".block")[index].classList.add("selected");
                        selectEle(true);
                    }

                    //FOR SNAPPY SIDEBAR CLOSE ONCE USER CLICK TO EDIT
                    if(!document.querySelector("body").classList.contains("collapse-sidebar") && app.isMobile() !== "is-mobile"){
                        document.querySelector("body").classList.add("collapse-sidebar");
                    }
                })
            }
            if(ele.classList.contains("copyItem")) {
                const newData = JSON.parse(JSON.stringify(data.dynamicAIData[index]));
                newData["viewId"] = "aus_" + Date.now();
                data.dynamicAIData.splice(parseInt(index)+1, 0, newData);
 

                self.renderData(data, function(){
                    // console.log("renderData", index);
                    self.moveWidget(index, "copy") 
                }); 
            }
            if(ele.classList.contains("gridCopyItem")) {
                const newData = JSON.parse(JSON.stringify(data.dynamicAIData[index].elements[gridId].items[grid]));
                newData["gridId"] = `grid-${Date.now()}`;
                data.dynamicAIData[index].elements[gridId].items.splice(parseInt(grid)+1, 0, newData);
                self.renderData(data);
            }
            
            if(ele.classList.contains("moveUp")) {
                if(parseInt(index) !== 0) {
                    data.dynamicAIData.splice(parseInt(index) - 1, 0, data.dynamicAIData.splice(parseInt(index), 1)[0]);
                    self.renderData(data, function(){
                        self.moveWidget(index, "up") 
                    });
                }
            }
            if(ele.classList.contains("moveDown")) {
                if((parseInt(index) + 1) !== data.dynamicAIData.length) {
                    data.dynamicAIData.splice(parseInt(index) + 1, 0, data.dynamicAIData.splice(parseInt(index), 1)[0]);
                    self.renderData(data, function(){
                        self.moveWidget(index, "down") 
                    });
                }
            }
            if(ele.classList.contains("deleteItem")) { 
                let title = app.getLang("remove_section");
                let summary = app.getLang("are_you_sure");
                app.getCreateRoot("DeleteModal").render(<DeleteModal title={title} summary={summary} callback={function(){
                    data.dynamicAIData.splice(index, 1);
                    self.renderData(data);
                }}/>);  
            }
            if(ele.classList.contains("gridDeleteItem")) { 
                const div = document.createElement("div");
                let title = app.getLang("remove_section");
                let summary = app.getLang("are_you_sure");
                document.body.appendChild(div);
                app.getCreateRoot("DeleteModal").render(<DeleteModal title={title} summary={summary} callback={function(){
                    const nextData = JSON.parse(JSON.stringify(data));
                    nextData.dynamicAIData[index].elements[gridId].items.splice(grid, 1);
                    self.renderData(nextData);
                    if(document.querySelector(".main-editor")){
                        document.querySelector(".main-editor").style.display = "none";
                    }
                    
                }}/>, div);
            }

            if(ele.classList.contains("editBypass_mobile")) {  
                 document.querySelector(`#block-view-${index} .root-setting`).click();
            }
 
            
        }
    }

    moveWidget(index, type){
        // console.log("index", index)
        index = Number(index) 
        let widget = app.getDom().querySelector(`.page_body .block[data-index="${index}"]`);  
        let offsetTop = widget.offsetTop;
        let setHeight = offsetTop + widget.clientHeight;
        
        let scrollableWidgets = app.getDom().body;  
        if(type === 'up'){ 
            console.log("widget---", widget)
            let upWidget = widget.previousSibling;
            let upOffsetTop = widget.offsetTop;
            let upWidgetSetHeight = upOffsetTop - upWidget.clientHeight;

            setTimeout(function(){ 
                scrollableWidgets.scrollTop = upWidgetSetHeight; 
            },500)  
        }
        else if(type === 'down'){
            let downWidget = widget.nextSibling;
            let downOffsetTop = downWidget.offsetTop;
            let downWidgetSetHeight = downOffsetTop + downWidget.clientHeight - widget.clientHeight;
            setTimeout(function(){ 
                scrollableWidgets.scrollTop = downWidgetSetHeight; 
            },500) 
        }else if(type === 'addUp'){ 
            // console.log("type", "addUp")
            let addUpWidget = widget;
            let addUpOffsetTop = addUpWidget.offsetTop; 
            let addUpWidgetSetHeight = addUpOffsetTop; 
            setTimeout(function(){ 
                scrollableWidgets.scrollTop = addUpWidgetSetHeight; 
            },100)  
        }else if(type === 'addDown'){ 
            // console.log("type", "addDown")
            let addDownWidget = widget;
            let addDownOffsetTop = addDownWidget.offsetTop;
            let addDownWidgetSetHeight = addDownOffsetTop + addDownWidget.clientHeight;  
            setTimeout(function(){ 
                scrollableWidgets.scrollTop = addDownWidgetSetHeight; 
            },100) 
        }
        else{
            setTimeout(function(){
                scrollableWidgets.scrollTop = setHeight; 
            },500)
        }  
    }   
    unselect(mode) {
        console.log("unselect")
        this.setState({
            edit:{
                index:null,
                grid:null,
                id:null 
            }
        }, function(){ 

            //bottom right Sheet on Mobile
            if(document.querySelector("body").classList.contains("isBottomView")){
                document.querySelector("body").classList.remove("isBottomView");
            } 
            
            //current edit to do not remove bottom right Sheet
            app.getDom().querySelectorAll(".active").forEach(function(v){
                v.classList.remove("active"); 
                //v.removeAttribute("contenteditable");
            });

           

            //current edit to remove parent border
            app.getDom().querySelectorAll(".activeHover").forEach(function(v){
                v.classList.remove("activeHover"); 
            })
              
            //current edit to selected class
            app.getDom().querySelectorAll(".selected").forEach(function(v){
                v.classList.remove("selected");
            });

            //remove all hover
            app.getDom().querySelectorAll(".hover").forEach(function(v){
                v.classList.remove("hover");
            });

            if(!mode){ 
                document.querySelectorAll(".app-overlay .hover").forEach(function(v){
                    v.classList.remove("hover");
                    if(v.classList.contains("hoverMobile")){
                        v.classList.remove("hoverMobile");
                    }
                });
            }

            //hide current edit button
            document.querySelector(".main-editor").style.display = "none";

            //When i click on edit section on right sticky pan
            if(document.querySelector("body").classList.contains("rootEdit")){
                document.querySelector("body").classList.remove("rootEdit");
            }

            
           
        })
    }
    
    logoUpdate(logo) {
        const self = this;
        const {data} = self.state;
        const dynamicAIData = data.dynamicAIData;
        dynamicAIData.forEach(function(v){
            if(v.widgetType === "headerAi") {
                v.elements.logo.properties.src = logo;
            }
            if(v.widgetType === "footerAi") {
                v.elements.logo.properties.src = logo;
            }
        })
        self.updateData(dynamicAIData);
        updateLogoDB(logo);
    }
    componentDidMount() {
        const self = this;
        window.clickElement = self.clickElement;
        window.actionClick = self.actionClick;
        window.updateText = self.updateText;
        window.saveAiPage = self.saveAiPage;
        window.headerCallback = self.headerCallback;
        window.editorLink = self.editorLink;
        window.editorLink2 = self.editorLink2;
        window.logoUpdate = self.logoUpdate;
        

        localStorage.setItem("undo", JSON.stringify([]));
        localStorage.setItem("redo", JSON.stringify([]))
        
        
        let page = '/';
        if(window.location.pathname !== '/'){
            page = window.location.pathname.split('/')[1] 
        }
        app.fonts();
        if(self.props.data) {
          //  console.log(self.props.data);
            self.setState({
                data:self.props.data
            }, function(){
                self.loadIframe();
                self.renderPage(self.props.data, true);

                if(window.location.pathname === "/appmakr/creator-software/build") {
                    self.headerCallback("mobile")
                }
                if(window.location.pathname === "/website/creator-software/build") {
                    if (app.isMobile() === "is-mobile") { 
                        self.headerCallback("mobile")
                    }else{
                        self.headerCallback("desktop")
                    }
                }

                //window.addEventListener('resize', resizeWindow)
                function resizeWindow(){ 
                  if ( app.isMobile() === "is-mobile" ) {  
                      if(!document.querySelector("body").classList.contains("mobile-view")) {
                        document.querySelector("body").classList.add('mobile-view');  
                        if(document.querySelector(".wb-col .h-mobile")){
                            document.querySelector(".wb-col .h-mobile").click()
                        }
                      }
                    
                  }else{
                    if(document.querySelector("body").classList.contains("mobile-view")) { 
                        document.querySelector("body").classList.remove('mobile-view'); 
                        if(document.querySelector(".wb-col .h-desktop")){
                            document.querySelector(".wb-col .h-desktop").click()
                        }
                    } 
                  }
                }
                //resizeWindow();
            })
        }
        else {
            const response = app.localPage();
            self.setState({
                data:response
            }, function(){
                self.loadIframe();
                self.renderPage(response);
            })
            
        }
    }

    saveAiPage(callback) {
        const self = this; 
        if(self.props.publishPage) {
            const newData =  JSON.parse(JSON.stringify(self.state.data));
            console.log(newData);
            self.props.publishPage(newData, function(response){
                if(callback) {
                    callback(response);
                }
            });
        } 
    }
   

    loadIframe(response) {
        const self = this;
        app.getWin().onclick = function(event) { 
            //console.log("code for hide color update")
            if(document.querySelector(".acolorpickerNew.active")) {
                if(document.querySelector(".acolorpickerNew.active .close_picker")) {
                    document.querySelector(".acolorpickerNew.active .close_picker").click();
                }
            }
            if(app.isParents(event , "action-grid")) {

            }else{
                if(app.isParents(event , "block")) {
                    if(app.isParents(event , "elements-grid")) {
                        if(app.isParents(event , "elements")) {
                             console.log("elements 2");
                        }
                        else {
                            self.unselect();
                            console.log("elements-grid");
                        }
                    }
                    else {
                        if(app.isParents(event , "elements")) {
                            //self.unselect();
                            console.log("elements 1");
                        }
                        else {
                            self.unselect(true);
                             console.log("block");
                        }
                    }
                }
            }
           
            
        }
        app.scroll(function (top) {
            // console.log("top", top)
            document.querySelector(".app-overlay").style.top = "-" + top + "px";
            const selectedEl = app.getDom().querySelector(".selected"); 
            // const currentOverlay = app.getDom().querySelector(".block.on"); 
            if (selectedEl) { 
                // console.log("selectedEl", selectedEl)
              let offsetTop = getOffset(selectedEl).top; 
              if (offsetTop !== null || offsetTop !== undefined) {
                if (top > (offsetTop + selectedEl.clientHeight)) {
                  self.unselect(); 
                }
                else {
                  if (top < (offsetTop - window.document.body.clientHeight)) {
                    self.unselect(); 
                  }
                }
              }
            }else{
                const selectedMobile = document.querySelector(".block-view.hover"); 
                if(selectedMobile && app.isMobile() === "is-mobile"){
                    let offsetTop = getOffset(selectedMobile).top; 
                    if (offsetTop !== null || offsetTop !== undefined) {
                        if (top > (offsetTop + selectedMobile.clientHeight + 100)) {
                        self.unselect(); 
                        }
                        else {
                        if (top < (offsetTop - window.document.body.clientHeight  + 100)) {
                            self.unselect(); 
                        }
                        }
                    }
                }
            }
        })
        cssFiles.forEach(function(v){
            if(app.appLang() === "sa") {
                if(v.indexOf("bootstrap.min.css") !== -1) {
                    v = "https://media.mediadirhub.com/css/bootstrap.rtl.min.css";
                }
            }
            app.loadCSS(v);
        })
        jsFiles.forEach(function(v){
            app.loadJS(v);
        })
    }
    renderPage(response, mode) {
        const self = this;
        const iframe = app.getDom();
        if(self.props.type) {
            iframe.body.classList.add("block-edit");
            if(app.appLang() === "sa") {
                iframe.querySelector("html").setAttribute("lang", "sa");
                iframe.querySelector("html").setAttribute("dir", "rtl");
                iframe.body.classList.add("sa");
            }
        }
       // console.log(app.getDevice()?"desktop":"mobile");
        iframe.body.classList.add("editor-mode");
        if(window.location.href.indexOf("/header") !== -1 || window.location.href.indexOf("/footer") !== -1) {
            iframe.body.classList.add("header-mode");
        }
       
        const root = ReactDOM.createRoot(iframe.body);
        root.render(<Widget data={response} mode="edit" device={app.getDevice()?"desktop":"mobile"} />, iframe.body);
        app.resizeBlockView();
        let page = '/';
        localStorage.setItem("aiPageData", JSON.stringify(response));
        if(window.location.pathname !== '/'){
            page = window.location.pathname.split('/')[1] 
        }
        //console.log("mode", mode);
        if(!mode) {
            if(self.props.callback) {
                self.props.callback(response, true);
            }
            else {
                app.savePage(page, response);
            }
        }
        app.setFonts(response);
    }
    updateData(response, mode) {
        const self = this;
        app.saveUndo(self.state.data);
        const newData =  JSON.parse(JSON.stringify(self.state.data));
        newData.dynamicAIData = response;
        self.setState({
            data:newData
        }, function(){
            if(mode) {
                self.autoSave();
            }
            else {
                self.renderPage(newData);
            }
        });
    }
    renderData(response, callback) {
        const self = this;
        app.saveUndo(self.state.data);
        self.setState({
            data:response
        }, function(){
            self.renderPage(response);
            if(callback) {
                callback();
            }
        })
    }
    bindHTML() {
        this.renderPage(this.state.data, true)
    }
    newPublishPage() {
        const self = this;
        if(self.props.publishPage) {
            self.props.publishPage(self.state.data);
        }
    }
    editorLink(e) { 
        const self = this;
        if(e.currentTarget.getAttribute("data-type") === "unlink") {
            window.iframeUnlink();
            self.textUpdate();
            self.unselect()
        }
        else {
            linkPopup(e.currentTarget.getAttribute("data-href"), 0, function(link){
                window.iframeLink(link);
                self.textUpdate();
                self.unselect()
                // console.log("e.currentTarget.getAttribute", e.currentTarget)
                // if(document.querySelector(".main-editor")){
                //     document.querySelector(".main-editor").style.display = "none";
                // } 
            }, true, null)
        }
    }
    getSelectedText() {
        var text = "";
        if (window.getSelection) {
            text = window.getSelection().toString();
        } else if (document.selection && document.selection.type != "Control") {
            text = document.selection.createRange().text;
        }
        return text;
      }

    editorLink2(e) {
        // console.log("editorLink2")
        const self = this;
        window.saveSelection();  
        if(e.currentTarget.getAttribute("data-type") === "unlink") {
            window.rootUnlink();
            self.textUpdate();
        }
        else {
            linkPopup(e.currentTarget.getAttribute("data-href"), 0, function(link){
                // window.rootLink(link, selectedText); 
                window.restoreSelection();  
                if(window.getSelection().toString()) {
                    window.rootLink(link); 
                }
                self.textUpdate();
                if(document.querySelector(".main-editor")){
                    document.querySelector(".main-editor").style.display = "none";
                } 
            }, true, null)
        }
    }

    aiPopup(){ 
        const div = document.createElement("div");
        document.body.appendChild(div);
        ReactDOM.render(<AiModal update={this.textUpdate} />, div);
    }
 
    rootSetting(event, index){
        // alert("aaaaaa")
        let ele = event.currentTarget;
        // console.log("ele.parentElement.classList", ele.parentElement.classList.contains("hover"))
       //return false
        //For real Mobile when you click on Setting icon to calculate height to show bottom edit section
        document.body.classList.add("isRoot");  
        app.getDom().body.classList.add("isRoot");
        //When i click on Any element section I added bottomSheet class to hide right sticky pan
        document.body.classList.add("bottomSheet"); 

        //remove all hover
        document.querySelectorAll(".hover").forEach(function(v){
            v.classList.remove("hover");
        }); 
     

        //bottom right Sheet on Mobile
        if(document.querySelector("body").classList.contains("isBottomView")){
            document.querySelector("body").classList.remove("isBottomView");
        }    

        //When i click on edit section on right sticky pan
        if(document.querySelector("body").classList.contains("rootEdit")){
            document.querySelector("body").classList.remove("rootEdit");
        }

        app.getDom().querySelectorAll(".block-area").forEach(function(v){
            if(v.getAttribute('data-index') == index){ 
                v.classList.add("selected"); 
            }else{
                v.classList.remove("selected"); 
            }
        }); 
        
        if(ele.parentElement.classList.contains("hoverMobile")){
            ele.parentElement.classList.remove("hoverMobile");
            ele.parentElement.classList.remove("hover");
        }else{
            document.querySelectorAll(".hoverMobile").forEach(function(v){
                v.classList.remove("hoverMobile");
            });  
            ele.parentElement.classList.add("hoverMobile");
            ele.parentElement.classList.add("hover");
        }
        
        
    }
    autoSave() {
        const self = this;
        const {data} = self.state;
        if(self.props.callback) {
            self.props.callback(data, true);
        }
        else {
            let page = '/';
            if(window.location.pathname !== '/'){
                page = window.location.pathname.split('/')[1] 
            }
            app.savePage(page, data);
        }
    }
    scrollIframe(event) {
        var iframe = document.getElementById('iframe');
        if (iframe) { 
            var deltaY = event.deltaY;
        //   console.log("deltaY", deltaY)
            if(iframe.contentWindow){
            iframe.contentWindow.scrollBy(0, deltaY);
            // event.preventDefault();
            } 
        }
    }
    handleTouchStart = (event) => {
        this.touchStartY = event.touches[0].clientY;
    } 
    handleTouchMove = (event) => {
        this.touchEndY = event.touches[0].clientY;
        const deltaY = this.touchStartY - this.touchEndY;

        const iframe = document.getElementById('iframe');
        if (iframe && iframe.contentWindow) {
            iframe.contentWindow.scrollBy(0, deltaY);
        } 
        this.touchStartY = this.touchEndY;
    }
    
    render() {
        const self = this;
        const {data, edit, langSettings, expand} = self.state;
        if(data === null) {
            return <div>Loading</div>
        }
        let previewButton =  <Link className="wb-text preview" href={`/desktop-preview/pages/${data.id}`}>{langSettings.preview}</Link>
        

        let wrapStyle = {height:"calc(100% - 55px)", marginTop:"55px"};
        let wrapFlex = {};
        let wrapMobile = ""
        //if(window.location.href.indexOf("localhost:") !== -1) {
        if(app.getProject() === "live" && window.location.href.indexOf("localhost:") == -1){
            if(!app.getDevice()){
                wrapMobile = "wrapMobile"
                wrapFlex = {display: "flow-root"}
            }else{
                wrapStyle = {height:"100%", marginTop:"0px"}
            } 
        } 

        let previewIframe = "";
        if(expand) {
            previewIframe = <PreviewIframe />
        }
       
       
        return <div className="w-100 h-100 position-relative" style={wrapFlex}>
          
                <div className={`wb-header ${app.getProject()==='live' && window.location.href.indexOf("localhost:") == -1?"d-none":""}`} style={{top:0}} data-type={self.props.type} data-project={app.getProject()}>
                    <div className="wb-col d-flex d-none">
                        <a  className="wb-text ps-0" onClick={() => newBackPage()}><i className="icon-left-open"></i> {langSettings.back}</a>
                    </div>
                    <ViewPort change={self.bindHTML} unselect={self.unselect} />
                    <UndoRedo type={"mobile"} update={self.undoRedo} />
                    <div className="wb-col">
                        {/* <a className="loading-text wb-text disabled">Saved</a>
                        <a>|</a> */}
                        {previewButton}
                        <a className="btn btn-primary" data-type="publish" onClick={self.newPublishPage}>{langSettings.save}</a>
                    </div>
                </div>
           
            <div className={`w-100 iframe-wrapper mx-auto ${wrapMobile}`} style={wrapStyle} onWheel={this.scrollIframe} onTouchStart={app.getDevice() ? null : this.handleTouchStart} onTouchMove={app.getDevice() ? null : this.handleTouchMove} >
            <div className="back-overlay-click h-100 position-absolute top-0 start-0" onClick={() => self.unselect()} style={{width:"calc(50% - 200px)", zIndex:"1"}}></div>
            <div className="back-overlay-click h-100 position-absolute top-0 end-0" onClick={() => self.unselect()} style={{width:"calc(50% - 200px)", zIndex:"1"}}></div>


                <iframe id="iframe" className="border-0 w-100 h-100" onLoad={function(){
                    self.loadIframe();
                    self.renderPage(self.state.data);
                    
                }}></iframe>
            </div>
             
            <div className="app-overlay"> 
            {
                data.dynamicAIData.map(function(v, i){
                    let itemClass = ""; 
                    // Find the index of the first "headerAi" and "footerAi"
                    const headerIndex = data.dynamicAIData.findIndex(item => item.widgetType === "headerAi");
                    const footerIndex = data.dynamicAIData.findIndex(item => item.widgetType === "footerAi");

                    // Handle case where there's only one element in dynamicAIData
                    if (data.dynamicAIData.length === 1) {
                        if (v.widgetType !== "headerAi" && v.widgetType !== "footerAi") {
                            itemClass = "first-child last-child";
                        }
                    } else {
                        // If it's the first element and it's not a header, apply "first-child"
                        if (i === 0 && v.widgetType !== "headerAi") {
                            itemClass = "first-child";
                        }
                        // Skip applying "first-child" if it's immediately after the header
                        if (i === 1 && headerIndex === 0) {
                            itemClass = "first-child"; // Clear any previously assigned class for first child
                        }

                        // If it's the last element and it's not a footer, apply "last-child"
                        if ((data.dynamicAIData.length - 1) === i && v.widgetType !== "footerAi") {
                            itemClass = "last-child";
                        }
                        // Skip applying "last-child" if it's immediately before the footer
                        if ((data.dynamicAIData.length - 2) === i && footerIndex === data.dynamicAIData.length - 1) {
                            itemClass = "last-child"; // Clear any previously assigned class for last child
                        }
                    }

                    return (
                        <div id={`block-view-${i}`} data-index={i} key={`b${v.viewId}`} widget-type={v.widgetType} className={`block-view ${itemClass}`}>
                            {app.isMobile() ? (
                                <button 
                                    type="button" 
                                    className="close-popup modal-close position-relative ic_ai_icon_game_setting_8 root-setting d-none" 
                                    onClick={(e) => self.rootSetting(e, i)}
                                ></button>
                            ) : null}
                            
                            <ActionBlock 
                                langSettings={langSettings} 
                                actionClick={self.actionClick} 
                                index={i} 
                                widgetType={v.widgetType} 
                            />
                        </div>
                    );
                })
            }

              
                    {/* {
                        data.dynamicAIData.map(function(v, i){
                            
                            let itemClass = "";
                            if(data.dynamicAIData.length === 1){
                                itemClass = "first-child last-child"
                            }else{
                                if(i === 0) {
                                    itemClass = "first-child";
                                }
                                if((data.dynamicAIData.length - 1) === i) {
                                    itemClass = "last-child";
                                }
                            }
                            
                            return <div id={`block-view-${i}`} data-index={i} key={`b${v.viewId}`} widget-type={v.widgetType} className={`block-view ${itemClass}`}>
                               {app.isMobile()?<button type="button" className="close-popup modal-close position-relative ic_ai_icon_game_setting_8 root-setting d-none" onClick={(e)=>self.rootSetting(e, i)}></button>:null}
                            <ActionBlock langSettings={langSettings} actionClick={self.actionClick} index={i} widgetType={v.widgetType}/>
                            </div>
                        })
                    } */}

 



                   
               
                    <DisplayForms key={"DisplayForms"} edit={edit} data={JSON.parse(JSON.stringify(data.dynamicAIData))} update={self.updateData} unselect={self.unselect} />
                
              
                <div className="editor-element main-editor" data-type="bold">
                    <ul className="z_list">
                        <li><a onClick={self.makeSelect} className="tool-tip">{svgIcon.edit}<span className="tooltip-text">{app.getLang("edit")}</span></a></li>
                        <li><a data-type="ai_generator" className="ai_generator tool-tip" onClick={self.aiPopup}>{svgIcon.ai}<span className="tooltip-text" style={{width:"80px"}}>{app.getLang("create_aI_text")}</span></a></li>  
                    </ul> 
                </div>
            </div> 
            {previewIframe}
    </div>
    }

    
}
